import { Helmet } from 'react-helmet'
import { Box } from '@mui/system'
import PageDisplay from 'components/PageDisplay/PageDisplay'
import { useUser } from 'app/User'
import ProceduresNurse from 'components/ProcedureList/ProceduresNurse'
import ProceduresRep from 'components/ProcedureList/ProceduresRep'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useGetPatientStatusOptions } from 'lib/services/restApi/organizations/organizations'
import { useAuth0 } from 'app/Auth'
import { useGetAppConfig } from 'lib/apollo/hooks'
import { useRoomViewStore } from 'store'
import { useGetRoomViewRooms } from './RoomView/hooks/rooms.hook'
import dayjs from 'lib/dayjs'

const Procedures: React.FC = () => {
  const navigate = useNavigate()
  const { isRep, user } = useUser()
  const { accessToken } = useAuth0()

  const { data: patientStatusOptionsData } =
    useGetPatientStatusOptions(accessToken)

  const { setRooms } = useRoomViewStore()

  const startOfDay = dayjs().startOf('day').toDate()
  const endOfDay = dayjs().endOf('day').toDate()

  const { data: roomViewRoomsData } = useGetRoomViewRooms({
    input: {
      startOfDay,
      endOfDay,
    },
  })

  const { setAllowPatientStatusRestrictedActions } = useRoomViewStore()
  const { data: appConfigData } = useGetAppConfig()

  useEffect(() => {
    if (
      appConfigData?.getAppConfig?.featureFlags?.hasOwnProperty(
        'allowPatientStatusRestrictedActions'
      )
    ) {
      setAllowPatientStatusRestrictedActions(
        appConfigData.getAppConfig.featureFlags
          .allowPatientStatusRestrictedActions
      )
    }
  }, [appConfigData, setAllowPatientStatusRestrictedActions])

  useEffect(() => {
    if (patientStatusOptionsData?.data) {
      localStorage.setItem(
        'patientStatusOptions',
        JSON.stringify(patientStatusOptionsData?.data)
      )
    }
  }, [patientStatusOptionsData])

  useEffect(() => {
    if (roomViewRoomsData?.getRoomViewRooms) {
      setRooms(roomViewRoomsData?.getRoomViewRooms)
    }
  }, [roomViewRoomsData?.getRoomViewRooms, setRooms])

  useEffect(() => {
    if (!user?.id) {
      window.location.reload()
    }
  }, [user])

  useEffect(() => {
    const inviteUrl = localStorage.getItem('inviteUrl')
    if (inviteUrl) {
      localStorage.removeItem('inviteUrl')
      navigate(inviteUrl)
    }
  }, [navigate])

  return (
    <>
      <Helmet>
        <title>Procedures</title>
      </Helmet>
      <PageDisplay>
        <Box px={1.5} pt={1.5}>
          {isRep ? <ProceduresRep /> : <ProceduresNurse />}
        </Box>
      </PageDisplay>
    </>
  )
}

export default Procedures
